import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { SummaryDateLine } from './SummaryDateLine';
import { timeFormatter } from '@act/shared/utilities';

interface AssignedSurveySummaryDateLineProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
}

export const AssignedSurveySummaryDateLine = ({
  assignedSurvey,
}: AssignedSurveySummaryDateLineProps) => {
  const date = assignedSurvey.completedAt ?? assignedSurvey.createdAt;
  const text = `Assigned on ${timeFormatter.epochToHumanReadableDate({
    date,
    showFullMonthName: true,
    excludeRelativeDay: true,
  })}`;

  return <SummaryDateLine text={text} />;
};
